export default {
    appSetting: "APP_SETTING",
    shippingLabel: "SHIPPING_LABEL",
    include: "INCLUDE",
    exclude: 'EXCLUDE',
    single: 'SINGLE',
    group: "GROUP",
    percentage: "PERCENTAGE",
    flatvalue: "FLAT_VALUE",
    userProfile: "USER_PROFILE",
    systemUserProfile: "SYSTEM_USER_PROFILE"
}